import { blossom, branch, drift, leaf, petal, wisteria } from '../motifs';
import { registerPlate } from '../registry';

const BLOOM = ['#e0c0ff', '#a070e0', '#6a3aa8'] as const;
const LEAF = ['#9ad06a', '#4e8a38', '#2c5a24'] as const;

/** 06 ผู้บำเพ็ญ: the ascetic's plate, violet lacquer under hanging wisteria, a violet tassel. */
registerPlate({
  id: 'ascetic',
  name: 'ผู้บำเพ็ญ',
  ground: ['#5c3e8e', '#3a2462', '#24143e'],
  trim: '#b89ae0',
  text: { fill: ['#f6eeff', '#d4bcf4'], line: '#140a24' },
  inset: [17, 11],
  tassels: [
    { x: 3, charm: 'knot' },
    { x: -4, tones: BLOOM, charm: 'jade', charmTones: ['#b8f0d0', '#4ab888', '#2a7a58'], len: 9, cord: 3 },
  ],
  front(p, f) {
    branch(
      p,
      [
        [f.x - 4, f.y - 3],
        [f.x + 6, f.y - 5],
        [f.x + 16, f.y - 2],
      ],
      1.6,
      0.7,
    );
    for (const [x, y] of [
      [f.x + 1, f.y - 5],
      [f.x + 10, f.y - 4],
    ] as const)
      leaf(p, x, y, -2.4, 5, 2, LEAF);
    wisteria(p, f.x - 2, f.y - 3, 28, BLOOM, -1);
    wisteria(p, f.x + 5, f.y - 5, 22, BLOOM, 1);
    wisteria(p, f.x + 12, f.y - 4, 15, BLOOM);
    blossom(p, f.r - 3, f.y + 1, 4, BLOOM);
    blossom(p, f.r + 2, f.y + 6, 3.2, BLOOM);
  },
  motion: {
    sprites: { petal: { w: 2, h: 2, draw: (p) => petal(p, 0, 0, BLOOM) } },
    play(a, t, f) {
      drift(a, 'petal', t, 3, f.x - 2, 14, f.y + 2, f.b + 12, { speed: 0.25 });
    },
  },
});
